import { Card, CardContent, Grid, Link, Typography } from '@material-ui/core';
import React from 'react';

interface IProps {
  qrCode: string;
  exhibitName: string;
}

const ExhibitQRCode: React.FC<IProps> = ({ qrCode, exhibitName }) => {
  var QRCode = require('qrcode.react');

  const downloadQR = () => {
    var svgData = document.getElementById('QRCode')?.outerHTML;
    var svgBlob = new Blob([svgData as BlobPart], {
      type: 'image/svg+xml;charset=utf-8',
    });
    var svgUrl = URL.createObjectURL(svgBlob);
    var downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = `${exhibitName} QRCode.svg`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Card>
      <CardContent>
        <Grid item xs={12}>
          <Typography variant='subtitle2'>QR Code</Typography>
        </Grid>
        <Grid
          container
          item
          justify='center'
          direction='column'
          alignItems='center'
        >
          <QRCode
            id='QRCode'
            value={qrCode}
            level='H'
            size={225}
            renderAs={'svg'}
          />
          <Link
            component='button'
            onClick={downloadQR}
            style={{ marginTop: '10px', fontWeight: 'bold' }}
          >
            Download
          </Link>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ExhibitQRCode;
